/**
 * Disclosure JS 
 * 
 *
 * For utilizing SASS to disclosure contents added solely by CMS users 
 * Ex. KeyMarketData on global-snapshot page 
 * (https://gwp.janushenderson.com/en-us/advisor/global-snapshot)
 */
(function(window, document, $, undefined) {
    $(function() {
      	if( global_data_layer.country === 'us' ) {
     		$( ".disclosures" ).addClass( "us" );
     	} else {
     		$( ".disclosures" ).addClass( "non-us" );
     	}
		
		// Hero bottom - Show more 
     	var hero_disclosures = $( '.component-disclosures' ).find('.show_more').prev().prop('className');
     	if( hero_disclosures !== undefined ) {
            if ( hero_disclosures.includes('disclosure-pending') ) {
         		$( '.component-disclosures .show_more' ).prev("div").css("border-bottom", "0"); 
         	} 
        }
        $('.component-disclosures').css('display', 'block');
    });
})( window, document, jQuery );